module.exports = __webpack_public_path__ + "img/replay.e216b47f.svg";